export default __webpack_public_path__ + "static/media/logo_brainpay_2.a4096a10.png";